import { request } from '@/api/v2/core';
import * as TaskTagTypes from '@/@types/tasksTypes';

/**
 * Fetches a list of all available task tags
 * @returns {Promise<TaskTagTypes.Tag[]>}
 */
export const fetchTags = () => {
  return request('tags', {
    method: 'GET'
  });
};

/**
 * Creates a new tag
 * @param {string} name the tag name
 * @returns {Promise<TaskTagTypes.Tag>} the new tag
 */
export const createTag = (name) => {
  return request('tags', {
    method: 'POST',
    data: {
      name
    }
  });
};
